import { useQuery } from '@tanstack/react-query';
import { OWASReportService } from '@/infra/services/owas-report';
import { OWAS_QUERY_KEYS } from './query-keys';

interface GetOWASResultParams {
	organization_id: string;
	company_id: string;
	file_id: string;
	id: string;
	finished: boolean;
}

const Service = OWASReportService.getInstance();

export const useGetOWASResult = (params: GetOWASResultParams) => {
	return useQuery([OWAS_QUERY_KEYS.GET_RESULT, params], () => Service.getResults(params), {
		enabled: !!params.organization_id && !!params.company_id && !!params.file_id && !!params.finished
	});
};
